import React from 'react'
import LoadingButton from './ui/LoadingButton'
import SchemaForm from './SchemaForm'

const schema = {
  name: {
    required: true,
    label: false,
    attrs: {placeholder: 'Token name'}
  }
}

export default class extends React.Component {
  render () {
    return <SchemaForm
      className='token-form'
      schema={schema}
      value={{}}
      onSubmit={this.props.onSave}
      button={props =>
        <span className='btn-group'>
          <LoadingButton type='submit' ui={props.ui}>Save</LoadingButton>
          <a role='button' onClick={this.props.onDismiss}>Cancel</a>
        </span>
      }
    />
  }
}



// WEBPACK FOOTER //
// ./app/components/TokenForm.js